export const PRIVACY_DASHBOARD_PATH = "/privacy-dashboard";
